var _circle, _circle2, _g, _g2, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestPayment = function SvgRequestPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#65C1B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Request_Payment_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Request_Payment_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -7,
    y: 26.8,
    width: 28.8,
    height: 28.8,
    rx: 1.667,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 39.8,
    cy: 6.4,
    r: 14.4,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -6,
    y: 12,
    width: 38,
    height: 28,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: 10,
    width: 38,
    height: 28,
    rx: 3,
    fill: "#B2E0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12H11v24h10a7 7 0 0 1 7-7V19a7 7 0 0 1-7-7ZM1 36h10V12H1a7 7 0 0 1-7 7v10a7 7 0 0 1 7 7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 24,
    r: 9,
    fill: "#3EB2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20.423V19.5h-1v.93c-1.371.16-2.313.968-2.313 2.064 0 1.032.642 1.624 2.025 1.936l.288.063v1.954c-.565-.109-.922-.402-1.063-.82H9c.115 1.109 1.046 1.824 2.5 1.952v.921h1v-.926c1.47-.155 2.5-.979 2.5-2.151 0-1.019-.648-1.585-2.031-1.89l-.469-.105v-1.87c.536.105.879.39.983.79h1.377c-.126-1.097-1-1.793-2.36-1.925Zm-1 1.146c-.534.12-.896.431-.896.849 0 .365.286.612.896.783v-1.633Zm1 3.145v1.738c.634-.111 1.05-.447 1.05-.896 0-.41-.335-.676-1.05-.842Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Request_Payment_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 25,
    height: 25,
    rx: 4,
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 31.594,
    r: 3.125,
    fill: "#3EB2A2",
    stroke: "#3EB2A2",
    strokeWidth: 1.029,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.25 40.323c0-.773.314-1.52.98-1.914 1-.593 2.765-1.346 5.27-1.346 2.505 0 4.27.753 5.27 1.346.666.394.98 1.14.98 1.914v.494c0 .947-.767 1.714-1.714 1.714h-9.072a1.714 1.714 0 0 1-1.714-1.714v-.494Z",
    fill: "#3EB2A2",
    stroke: "#3EB2A2",
    strokeWidth: 1.029,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Request_Payment_svg__b",
    x: 16,
    y: 18,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_166_1803"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.396078 0 0 0 0 0.341176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_166_1803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_166_1803",
    result: "shape"
  })))));
};
export default SvgRequestPayment;